/**
 * Fired on `document` the first time AppComponent has something to show.
 *
 * Shared between the Angular app (which dispatches it) and the AEM launcher (which listens for it
 * to drop its placeholder). The launcher used to guess with `setTimeout(…, 1500)`, which on stage
 * fired ~450 ms before the first app paint - the placeholder went away while the app was still
 * blank.
 */
export const APP_READY_EVENT = 'nutz:app-ready';
